import React from 'react';
import { connect } from 'react-redux';

import {
  makeGetIsTier1Offer,
  makeGetIsTier2Offer,
  makeGetDefaultTier1OfferBadgeText
} from '../redux';
import { getLtoOfferBadgeText } from 'page_modules/business-pdp/redux';

import LazyScrollMetricTracker from 'src/universal/components/DTM/LazyScrollMetricTracker';
import { getOfferStylingDtm } from 'src/universal/utils/offerStyling';
import { sendDTMCustomEvent } from 'service_modules/models/dtm-tagging';
import { getPznInfo } from 'src/universal/redux/pznData.js';
import { Breakpoint } from '@americanexpress/aqx-components';

import styles from '../__styles__/ribbon.scss?modules';

export const POSITIONS = {
  TILE_RIBBON: 'TILE_RIBBON',
  OFFER_BOX_RIBBON: 'OFFER_BOX_RIBBON'
};

const Ribbon = ({
  position,
  isTier1Offer,
  isTier2Offer,
  defaultTier1OfferBadgeText,
  offerStylingRibbonDtm,
  hasPznArrived,
  ltoOfferBadgeText
}) => {
  if (
    (!isTier1Offer && !isTier2Offer) ||
    (isTier1Offer && position === POSITIONS.OFFER_BOX_RIBBON) ||
    (!isTier1Offer && position === POSITIONS.TILE_RIBBON)
  ) {
    return null;
  }

  let text;

  if (!isTier2Offer && isTier1Offer) {
    text = defaultTier1OfferBadgeText;
  } else {
    text = ltoOfferBadgeText;
  }

  let tabletText;

  if (text.includes('| ')) {
    tabletText = (
      <React.Fragment>
        {text.split('| ')[0]} | <br />
        {text.split('| ')[1]}
      </React.Fragment>
    );
  } else {
    tabletText = text;
  }

  const lazyLoadCallback = () => {
    sendDTMCustomEvent(offerStylingRibbonDtm);
  };

  return (
    hasPznArrived && (
      <>
        <LazyScrollMetricTracker
          callBackFunction={lazyLoadCallback}
          startTrackingAfterPznArrival={true}
        />
        <Breakpoint>
          {({ md }) => {
            if (md) {
              return <div className={styles.container}>{tabletText}</div>;
            } else {
              return <div className={styles.container}>{text}</div>;
            }
          }}
        </Breakpoint>
      </>
    )
  );
};

const mapStateToProps = () => {
  const getIsTier1Offer = makeGetIsTier1Offer();
  const getIsTier2Offer = makeGetIsTier2Offer();
  const getDefaultTier1OfferBadgeText = makeGetDefaultTier1OfferBadgeText();
  return (state, { shortName }) => ({
    isTier1Offer: getIsTier1Offer(state, shortName),
    isTier2Offer: getIsTier2Offer(state, shortName),
    defaultTier1OfferBadgeText: getDefaultTier1OfferBadgeText(state, shortName),
    offerStylingRibbonDtm: getOfferStylingDtm(state, shortName),
    hasPznArrived: getPznInfo(state).hasPznArrived,
    ltoOfferBadgeText: getLtoOfferBadgeText(state, shortName)
  });
};

export default connect(mapStateToProps)(Ribbon);
